// extracted by mini-css-extract-plugin
export default {"formSubmit":"index_formSubmit_6w1r2","formSubmitSave":"index_formSubmitSave_c1mss","formSubmitButton":"index_formSubmitButton_BekUb"};